import * as React from 'react'

const FaceIdFilled = ({
  title,
  titleId,
  ...props
}: {
  title?: string
  titleId?: string
} & React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="#400099"
    focusable={false}
    aria-hidden
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M12.104 19.75c-4.226 0-7.647-3.472-7.647-7.75 0-4.278 3.421-7.75 7.647-7.75 4.225 0 7.646 3.472 7.646 7.75 0 4.278-3.42 7.75-7.646 7.75zm2.926-7.382c.664 0 1.2-.53 1.2-1.184A1.19 1.19 0 0015.03 10c-.663 0-1.2.53-1.2 1.184 0 .654.537 1.184 1.2 1.184zm-4.906-1.184c0-.655-.537-1.184-1.201-1.184-.663 0-1.2.53-1.2 1.184 0 .654.537 1.184 1.2 1.184.664 0 1.2-.53 1.2-1.184zm2.775 3.523a1.093 1.093 0 01-1.804-.008.75.75 0 00-1.238.847 2.592 2.592 0 004.273.019.75.75 0 00-1.23-.858zm7.611 2.045a.75.75 0 011.5 0v3.508a1.75 1.75 0 01-1.75 1.75h-3.514a.75.75 0 010-1.5h3.514a.25.25 0 00.25-.25v-3.508zM7.266 20.535a.75.75 0 010 1.5H3.758a1.75 1.75 0 01-1.75-1.75v-3.514a.75.75 0 111.5 0v3.514c0 .138.112.25.25.25h3.508zm9.473-17.01a.75.75 0 110-1.5h3.508c.966 0 1.75.783 1.75 1.75v3.514a.75.75 0 01-1.5 0V3.775a.25.25 0 00-.25-.25h-3.508zM3.528 7.28a.75.75 0 01-1.5 0V3.772c0-.966.783-1.75 1.75-1.75h3.514a.75.75 0 110 1.5H3.778a.25.25 0 00-.25.25V7.28z" />
  </svg>
)

export default FaceIdFilled
